export default __webpack_public_path__ + "static/media/fluff.99e184f5.svg";